export default __webpack_public_path__ + "static/media/google-play.ba160619.svg";